module.exports = __webpack_public_path__ + "static/media/dubleBg1.a98bbd02.png";